import React, { Component, Fragment } from 'react'
import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  InputNumber,
  MagicInput,
  message,
  Modal,
  Radio,
  Select,
  Spin,
  Tag,
  Upload,
  Row
} from 'hljd'
import isNil from 'lodash/isNil'
import { observer } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
// import FormClipUpload from '@common/FormClipUpload'
// import FormImgGallery from '@common/FormImgGallery'
import Store from './store'
import style from './style.module.less'
import InitRouterView from '@common/InitRouterView'
import CoversUploader, { CoversUploaderValidator } from './CoversUploader'
import { getMerchantInfo, isHunlitang, isCrawlerMerchant } from '@util'
import { toJS } from 'mobx'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import CaseItem from './CaseItem'
import UploadItem from './UploadItem'
import { arrayMove } from 'react-sortable-hoc-new'
import {
  facilitiesConfig,
  otherFeeRadioConfig
} from '@components/Hotel/WeddingHall/Edit/store'
// import { Form } from '@ant-design/compatible'
// import '@ant-design/compatible/assets/index.css'
// import 'antd4/lib/grid/style/index.css'

const Option = Select.Option
const CheckableTag = Tag.CheckableTag

const inputStyle = { style: { width: 200 } }
const nature_items_sample = [
  'https://qnm.hunliji.com/Fk_WaibOUgSTvbPwgVTz29KnfFVl',
  'https://qnm.hunliji.com/FncWYyCUIJvAhr-cr9WiO5QN4fk3',
  'https://qnm.hunliji.com/FhOlab724T09c7UHFGqAXkV8wGWR',
  'https://qnm.hunliji.com/FpeyQpmQhWqqe4uJ5Zs5AwvE6wAZ',
  'https://qnm.hunliji.com/Fr97ZDGqV1PaMWOU7rm7U6M7CtBm',
  'https://qnm.hunliji.com/FuMJe-hjSjz55q1Dk3B1hicPyI0m'
]
const decorative_items_sample = [
  'https://qnm.hunliji.com/FhWRZWUxfv1Gq5N00tZNkNqvQAml',
  'https://qnm.hunliji.com/FvKSZ-zwxp-dh6iAoFW4aM0jPIq3',
  'https://qnm.hunliji.com/Fjg9U6rualjPL-mwSoK0V-RNI8Dj',
  'https://qnm.hunliji.com/FpA_Ek7JoCwHEJURCNKI2i9plY6s'
]
const facilitiesDescStyle = { color: '#7F7F7F', lineHeight: '32px' }

@DragDropContext(HTML5Backend)
@InitRouterView()
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store(
      this.props.params.id,
      this.props.location.query.isFromShuijing,
      isHunlitang()
    )
    this.state = {
      site_type: null,
      showSampleModal: false,
      sampleImgs: []
    }
    this.getData()
  }
  formRef = React.createRef()
  getData = () => {
    const { type, id } = this.store
    this.store.getHallMarks()
    if (type == 'edit') {
      this.store.getDetail(id)
    }
    if (!!+getMerchantInfo().top_wedding) {
      this.store.getTopWeddingTag()
    }
  }

  submit = values => {
    console.log('values:', values)
    this.store.editHall(values)
  }
  onFinishFailed = ({ values, errorFields }) => {
    if (errorFields.find(item => item.name?.[0] === 'nature_items_1')) {
      const errorsItem = errorFields.find(
        item => item.name?.[0] === 'nature_items_1'
      )
      errorsItem.errors.forEach(item => {
        message.error(item)
      })
    }
    console.log('验证失败：', errorFields)
    // this.formRef.current.scrollToField(errorFields[0].name)
  }
  validatorInputRange = (rule, value, callback) => {
    if (!value) {
      callback('桌数范围不能为空')
      return
    }
    if (!value[0]) {
      callback(`最小起订桌数不能为${value[0] === 0 ? 0 : '空'}`)
      return
    }
    if (!value[1]) {
      callback(`最大起订桌数不能为${value[0] === 0 ? 0 : '空'}`)
      return
    }

    if (value[0] >= value[1]) {
      callback('最大桌数不能小于等于最小桌数')
      return
    }
    callback()
  }

  onSiteTypeChange = e => {
    console.log('site_type', e.target.value)
    this.setState({
      site_type: e.target.value
    })
  }
  showSampleImg = type => {
    const imgs =
      type === 'nature_items' ? nature_items_sample : decorative_items_sample
    this.setState({
      showSampleModal: true,
      sampleImgs: imgs
    })
  }
  onBeforeUpload = async (file, fileList) => {
    const { width } = await Upload.checkSizeSync(file)
    if (width < 540) {
      message.error('图片宽度不能小于540')
      return Promise.reject(file)
    }
    if (file.size > 20 * 1024 * 1024) {
      message.error('图片大小不能超过20M')
      return Promise.reject(file)
    }
    return Promise.resolve(file)
  }
  handleCancel = () => {
    this.setState({
      showSampleModal: false
    })
  }
  itemRender = type => (node, file, fileList) => {
    let index = fileList.findIndex(item => item.uid === file.uid)
    return (
      <UploadItem
        id={`${type}-${index}`}
        node={node}
        handleDrag={this.handleDrag}
      />
    )
  }
  // 处理拖动
  handleDrag = (dragId, dropId) => {
    const [typeDrag, dragIndex] = dragId.split('-')
    const [typeDrop, dropIndex] = dropId.split('-')
    const values = this.formRef.current.getFieldsValue([
      'decorative_items',
      'nature_items_1'
    ])
    if (typeDrag === typeDrop) {
      values[typeDrag] = this.handleUid(
        arrayMove(values[typeDrag], +dragIndex, +dropIndex)
      )
    } else {
      const dataDrop = [...values[typeDrop]]
      const dataDrag = [...values[typeDrag]]
      dataDrop.splice(+dropIndex + 1, 0, values[typeDrag][+dragIndex])
      dataDrag.splice(+dragIndex, 1)
      values[typeDrop] = this.handleUid(dataDrop)
      values[typeDrag] = this.handleUid(dataDrag)
    }
    this.formRef.current.setFieldsValue(values)
  }
  // 每次拖动的时候，处理一下uid，避免重复
  handleUid = list =>
    list.map((item, index) => {
      if (item.uid) {
        item.uid = `-${index + 1}`
      }
      if (item.response?.uid) {
        item.response.uid = `-${index + 1}`
      }
      return item
    })

  render() {
    let {
      id,
      detail: {
        name,
        max_table_num,
        best_table_num,
        area,
        height,
        pillar,
        shape,
        cover_url,
        vertical_cover_url,
        nature_items,
        case_items,
        service_option_desc,
        cover_width,
        cover_height,
        vertical_width,
        vertical_height,
        hall_type,
        hall_feature,
        floor_num,
        max_people_num
      },
      loading,
      submitLoading,
      changeTopWeddingTags,
      selectedTopWeddingTag
    } = this.store

    nature_items = toJS(nature_items) || []
    case_items = toJS(case_items) || (!isHunlitang() ? [[]] : [])
    const coversUrls = {
      cover_url,
      vertical_cover_url,
      cover_width,
      cover_height,
      vertical_width,
      vertical_height
    }

    const topWeddingTags = toJS(this.store.topWeddingTags)

    const header = this.props.viewData.header
    const siteType = this.state.site_type || hall_type || 1
    const { showSampleModal, site_type, sampleImgs } = this.state
    return (
      <HeaderView
        title="场地管理"
        className={style.wrapper}
        contentStyle={{ padding: 0, background: '#F2F3F6' }}
        header={header}
      >
        {loading ? (
          <div style={{ textAlign: 'center', marginTop: 120 }}>
            <Spin size="large" spinning={loading} />
          </div>
        ) : (
          <Form
            ref={this.formRef}
            labelCol={{ span: 4 }}
            layout="horizontal"
            colon={false}
            className={style.form}
            onFinish={this.submit}
            onFinishFailed={this.onFinishFailed}
            scrollToFirstError={true}
          >
            <Card title="基本信息" bordered={false}>
              <div className={style.content}>
                <Form.Item
                  label="场地类型"
                  name="hall_type"
                  initialValue={hall_type || 1}
                >
                  <Radio.Group onChange={this.onSiteTypeChange} disabled={!!id}>
                    <Radio value={1}>宴会厅</Radio>
                    <Radio value={2}>
                      特色场地（户外草坪、特色建筑、露台等）
                    </Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  label="场地名称"
                  name="name"
                  initialValue={name || ''}
                  rules={[
                    {
                      required: true,
                      message: '请输入场地名称'
                    }
                  ]}
                >
                  <MagicInput
                    placeholder="请输入场地名称、最多10个字"
                    maxLength={10}
                    showCount
                    countPosition="right"
                    style={{ width: 440 }}
                  />
                </Form.Item>

                {siteType === 1 && (
                  <>
                    <Form.Item
                      label="最多容纳桌数"
                      name="max_table_num"
                      initialValue={max_table_num}
                      rules={[
                        {
                          required: true
                        }
                      ]}
                    >
                      <InputNumber
                        min={1}
                        precision={0}
                        placeholder="最多能承接的婚宴桌数"
                        {...inputStyle}
                      />
                    </Form.Item>
                    <Form.Item
                      label="最佳容纳桌数"
                      name="best_table_num"
                      initialValue={best_table_num}
                      rules={[
                        {
                          validator: (_, values) => {
                            if (values <= 0) {
                              return Promise.reject('最佳容纳桌数不能为0')
                            } else {
                              return Promise.resolve()
                            }
                          }
                        }
                      ]}
                    >
                      <InputNumber
                        min={0}
                        precision={0}
                        placeholder="最适合承接的婚宴桌数"
                        {...inputStyle}
                      />
                    </Form.Item>
                    <Form.Item label="层高" required>
                      <Form.Item
                        name="height"
                        initialValue={height}
                        rules={[
                          {
                            required: true,
                            message: '请输入层高'
                          }
                        ]}
                        noStyle
                      >
                        <InputNumber
                          min={1}
                          precision={1}
                          placeholder="如8.8"
                          {...inputStyle}
                        />
                      </Form.Item>
                      <span className={style.info}>米</span>
                      {/*<div className={style.extra}>可精确到小数点后一位</div>*/}
                    </Form.Item>
                    <Form.Item
                      label="柱子"
                      required
                      name="pillar"
                      initialValue={pillar}
                      rules={[
                        {
                          required: true,
                          message: '请输入柱子数量'
                        }
                      ]}
                    >
                      <InputNumber
                        min={0}
                        precision={0}
                        placeholder="填写0，标识厅内无柱子"
                        {...inputStyle}
                      />
                    </Form.Item>
                    <Form.Item label="面积">
                      <Form.Item name="area_1" initialValue={area} noStyle>
                        <InputNumber placeholder="请输入面积" {...inputStyle} />
                      </Form.Item>
                      <span className={style.info}>平米</span>
                    </Form.Item>
                    <Form.Item label="形状">
                      <Form.Item name="shape_1" initialValue={shape} noStyle>
                        <Select placeholder="请选择" {...inputStyle}>
                          {/* <Option value="">请选择</Option> */}
                          <Option value="长方形">长方形</Option>
                          <Option value="正方形">正方形</Option>
                          <Option value="圆形">圆形</Option>
                          <Option value="半圆形">半圆形</Option>
                          <Option value="不规则">不规则</Option>
                        </Select>
                      </Form.Item>
                      {/* <div className={style.extra}>
                        不填，则该项用户无法查看该信息
                      </div>*/}
                    </Form.Item>
                    <Form.Item label="楼层">
                      <Form.Item
                        name="floor_num"
                        initialValue={floor_num}
                        noStyle
                      >
                        <InputNumber
                          min={-999}
                          max={999}
                          precision={0}
                          placeholder="点击填写"
                          {...inputStyle}
                        />
                      </Form.Item>
                      <span className={style.info}>层</span>
                    </Form.Item>
                    <Form.Item
                      label="场地特色"
                      name="hall_feature"
                      initialValue={hall_feature}
                    >
                      <MagicInput
                        placeholder="如：高穹顶、欧式主题婚礼、800平无柱宴会厅等"
                        maxLength={10}
                        showCount
                        countPosition="right"
                        style={{ width: 440 }}
                      />
                    </Form.Item>
                    <Form.Item
                      label="上传封面"
                      className={style.coverImg}
                      required
                    >
                      <div className={style.notice}>
                        横图展示在列表页和详情页头部， 最佳尺寸为988*616像素，
                        竖图展示在首页feeds流，
                        最佳尺寸为540*540像素，大小均不超过10M
                        ，支持JPG、PNG和BMP等常见图片格式。
                      </div>
                      <Form.Item
                        name="cover_urls_1"
                        initialValue={coversUrls || ''}
                        rules={[
                          {
                            required: true,
                            message: '请上传横图和竖图'
                          },
                          {
                            validator: CoversUploaderValidator
                          }
                        ]}
                        noStyle
                      >
                        <CoversUploader />
                      </Form.Item>
                    </Form.Item>
                    {!isHunlitang() && (
                      <>
                        <Form.Item label="上传裸厅图" required>
                          <div className={style.notice}>
                            裸厅图展示在宴会厅详情页，用来展示真实的场地情况，请不要上传效果图；至少上传3张，图片宽度最低540px，请勿添加水印、联系方式、边框、GIF。
                            <a
                              href="#"
                              onClick={e => {
                                e.preventDefault()
                                this.showSampleImg('nature_items')
                              }}
                            >
                              点击查看示例图
                            </a>
                          </div>
                          <Form.Item
                            name="nature_items_1"
                            validateTrigger="onBlur"
                            initialValue={nature_items || []}
                            rules={[
                              {
                                required: true,
                                message: '请上传裸厅图'
                              },
                              {
                                validator: (_, values) => {
                                  if (
                                    values?.length >= 3 &&
                                    values?.length <= 10
                                  ) {
                                    return Promise.resolve()
                                  } else {
                                    return Promise.reject(
                                      '至少上传3张裸厅图，至多上传10张裸厅图'
                                    )
                                  }
                                }
                              }
                            ]}
                            noStyle
                          >
                            <Upload
                              clipable
                              max={10}
                              sortable
                              multiple
                              listType="picture-card"
                              beforeUpload={this.onBeforeUpload}
                              itemRender={this.itemRender('nature_items_1')}
                            />
                          </Form.Item>
                        </Form.Item>
                        <Form.Item label="场地布置案例">
                          <div className={style.notice}>
                            您最多可以上传10组婚礼案例图片，请以一场婚礼的完整案例作为一组图片。可以拖动案例调整案例顺序。图片宽度最低540px，图片需在20M以内。
                          </div>
                          <Form.Item
                            name="case_items"
                            initialValue={case_items}
                            noStyle
                          >
                            <CaseItem />
                          </Form.Item>
                        </Form.Item>
                      </>
                    )}
                    {isHunlitang() && (
                      <Form.Item label="场地布置案例" required>
                        <div className={style.notice}>
                          场地布置案例展示在宴会厅详情页，用来展示婚礼现场的效果；至少上传1张，图片宽度最低540px，图片需在20M以内。请勿添加水印、联系方式、边框、GIF。
                          <a
                            href="#"
                            onClick={e => {
                              e.preventDefault()
                              this.showSampleImg('case_items')
                            }}
                          >
                            点击查看示例图
                          </a>
                        </div>
                        <Form.Item
                          name="case_items"
                          rules={[
                            {
                              required: true,
                              message: '请上传场地布置案例'
                            },
                            {
                              validator: (_, values) => {
                                if (
                                  values?.length > 0 &&
                                  values?.length <= 50
                                ) {
                                  return Promise.resolve()
                                } else {
                                  return Promise.reject('上传图片数不符合要求')
                                }
                              }
                            }
                          ]}
                          initialValue={case_items}
                          noStyle
                        >
                          <Upload
                            max={50}
                            sortable
                            multiple
                            listType="picture-card"
                            beforeUpload={this.onBeforeUpload}
                          />
                        </Form.Item>
                      </Form.Item>
                    )}
                  </>
                )}
                {siteType === 2 && (
                  <>
                    <Form.Item label="面积" required>
                      <Form.Item
                        name="area_2"
                        initialValue={area}
                        noStyle
                        rules={[{ required: true, message: '请输入场地面积' }]}
                      >
                        <InputNumber
                          placeholder="请输入场地面积"
                          {...inputStyle}
                        />
                      </Form.Item>
                      <span className={style.info}>平米</span>
                    </Form.Item>
                    <Form.Item label="形状">
                      <Form.Item name="shape_2" initialValue={shape} noStyle>
                        <Select placeholder="请选择" {...inputStyle}>
                          {/* <Option value="">请选择</Option> */}
                          <Option value="长方形">长方形</Option>
                          <Option value="正方形">正方形</Option>
                          <Option value="圆形">圆形</Option>
                          <Option value="半圆形">半圆形</Option>
                          <Option value="不规则">不规则</Option>
                        </Select>
                      </Form.Item>
                    </Form.Item>
                    <Form.Item label="楼层">
                      <Form.Item
                        name="floor_num"
                        initialValue={floor_num}
                        noStyle
                      >
                        <InputNumber
                          min={-999}
                          max={999}
                          precision={0}
                          placeholder="点击填写"
                          {...inputStyle}
                        />
                      </Form.Item>
                      <span className={style.info}>层</span>
                    </Form.Item>
                    <Form.Item
                      label="最多容纳人数"
                      name="max_people_num"
                      initialValue={max_people_num}
                      rules={[
                        {
                          validator: (_, values) => {
                            if (!isNil(values) && values <= 0) {
                              return Promise.reject('最多容纳人数不能为0')
                            } else {
                              return Promise.resolve()
                            }
                          }
                        }
                      ]}
                    >
                      <InputNumber
                        min={0}
                        precision={0}
                        placeholder="最多能容纳的人数"
                        {...inputStyle}
                      />
                    </Form.Item>
                    <Form.Item
                      label="场地特色"
                      name="hall_feature"
                      initialValue={hall_feature}
                      required
                      rules={[{ required: true, message: '请输入场地特色' }]}
                    >
                      <MagicInput
                        placeholder="如：中式摇橹船接亲、湖景花园露台、浪漫游艇婚礼等"
                        maxLength={10}
                        showCount
                        countPosition="right"
                        style={{ width: 440 }}
                      />
                    </Form.Item>

                    <Form.Item
                      label="上传封面"
                      className={style.coverImg}
                      required
                    >
                      <div className={style.notice}>
                        横图展示在列表页和详情页头部， 最佳尺寸为988*616像素，
                        竖图展示在首页feeds流，
                        最佳尺寸为540*540像素，大小均不超过10M
                        ，支持JPG、PNG和BMP等常见图片格式。
                      </div>
                      <Form.Item
                        name="cover_urls_2"
                        initialValue={coversUrls || ''}
                        rules={[
                          {
                            required: true,
                            message: '请上传横图和竖图'
                          },
                          {
                            validator: CoversUploaderValidator
                          }
                        ]}
                        noStyle
                      >
                        <CoversUploader />
                      </Form.Item>
                    </Form.Item>
                    <Form.Item label="上传实景图" required>
                      <div className={style.notice}>
                        实景图展示在场地详情页，至少上传1张，图片宽度1080px，高度最大不超过2160px，请勿添加水印、联系方式、边框、GIF
                        。
                      </div>
                      <Form.Item
                        name="nature_items_2"
                        initialValue={nature_items || []}
                        rules={[
                          {
                            required: true,
                            message: '请上传实景图'
                          }
                        ]}
                        noStyle
                      >
                        <Upload
                          max={50}
                          multiple={true}
                          sortable={true}
                          clipable={true}
                          beforeUpload={this.onBeforeUpload}
                        />
                      </Form.Item>
                    </Form.Item>
                  </>
                )}
              </div>
            </Card>

            <Card
              title="配套设施"
              bordered={false}
              className={style.service_desc}
            >
              <div className={style.content}>
                {facilitiesConfig.map(item => (
                  <Fragment key={item.name}>
                    <Form.Item
                      label={item.label}
                      name={[item.name, 'checked']}
                      initialValue={this.store.detail[item.name]?.checked}
                      rules={[
                        {
                          required: !isCrawlerMerchant(),
                          message: `请选择是否有${item.label}`
                        }
                      ]}
                    >
                      <Radio.Group className={style.checkbox}>
                        <Radio value={1}>有</Radio>
                        <Radio value={0}>无</Radio>
                      </Radio.Group>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={(pre, cur) =>
                        cur[item.name]?.['checked'] === 1 ||
                        cur[item.name]?.['checked'] !==
                          pre[item.name]?.['checked']
                      }
                      noStyle
                    >
                      {() =>
                        this.formRef?.current?.getFieldValue([
                          item.name,
                          'checked'
                        ]) === 1 && (
                          <Form.Item label=" ">
                            <div className={style.facilityContainer}>
                              <Form.Item
                                label={
                                  <span style={facilitiesDescStyle}>描述</span>
                                }
                                initialValue={
                                  this.store.detail[item.name]?.desc
                                }
                                name={[item.name, 'desc']}
                              >
                                <MagicInput
                                  placeholder="选填项；填写面积、尺寸等信息"
                                  maxLength={10}
                                  showCount
                                  countPosition={'inner'}
                                />
                              </Form.Item>
                              <Form.Item
                                label={
                                  <span style={facilitiesDescStyle}>图片</span>
                                }
                              >
                                <div style={facilitiesDescStyle}>
                                  选填项；请上传照片，最多3张；图片宽度最低540px，请勿添加水印、联系方式、边框、GIF。
                                </div>
                                <Form.Item
                                  name={[item.name, 'imgs']}
                                  noStyle
                                  initialValue={toJS(
                                    this.store.detail[item.name]?.imgs || []
                                  )}
                                >
                                  <Upload
                                    max={3}
                                    multiple={true}
                                    sortable={true}
                                    clipable={true}
                                    beforeUpload={this.onBeforeUpload}
                                  />
                                </Form.Item>
                              </Form.Item>
                            </div>
                          </Form.Item>
                        )
                      }
                    </Form.Item>
                  </Fragment>
                ))}
              </div>
            </Card>
            <Card
              title="其他费用"
              bordered={false}
              style={{ marginBottom: 136 }}
            >
              <div className={style.content}>
                <Row>
                  {otherFeeRadioConfig.map(item => (
                    <Col span={24} key={item.name}>
                      <Form.Item
                        label={item.label}
                        name={item.name}
                        labelCol={{ span: 3 }}
                        initialValue={this.store.detail?.[item.name]}
                        rules={[
                          {
                            required: !isCrawlerMerchant(),
                            message: `请选择是否有${item.label}`
                          }
                        ]}
                      >
                        <Radio.Group className={style.checkbox}>
                          <Radio value={1}>有</Radio>
                          <Radio value={0}>无</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                  ))}
                  <Col span={24}>
                    <Form.Item
                      label="其他说明"
                      labelCol={{ span: 3 }}
                      name="service_option_desc"
                      initialValue={service_option_desc}
                    >
                      <MagicInput.TextArea
                        placeholder="如有补充信息请在这里输入，如：该厅消费可赠送的服务内容，赠送婚房、香槟塔、精美台卡定制、专属个性仪式区布置等"
                        maxLength={150}
                        showCount
                        countPosition="inner"
                        style={{ width: 440 }}
                        rows={4}
                        autoSize={{ minRows: 4 }}
                      />
                    </Form.Item>
                  </Col>
                  {!!+getMerchantInfo().top_wedding && (
                    <Col span={24}>
                      <Form.Item
                        className={'tags'}
                        label={'高定标签'}
                        labelCol={{ span: 3 }}
                      >
                        {/* {topWeddingTags?.map(({ id, name }, i) => {
                          return (
                            <CheckableTag
                              key={i}
                              checked={selectedTopWeddingTag.some(
                                item => item == id
                              )}
                              className="border"
                              onChange={changeTopWeddingTags(id)}
                            >
                              {name}
                            </CheckableTag>
                          )
                        })} */}
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </div>
            </Card>

            <div className={style.bottom}>
              <div className={style['bottom-content']}>
                <div className={style.highlight} style={{ lineHeight: '20px' }}>
                  注：婚宴场地资料需要通过运营审核才能被用户看到。审核时间为1到2个工作日，在审核结束后，我们将通知您，请注意接收通知
                </div>
                <Button
                  loading={submitLoading}
                  type="primary"
                  className={style.submit}
                  htmlType="submit"
                >
                  提交审核
                </Button>
              </div>
            </div>
          </Form>
        )}
        <Modal
          title="示例图"
          visible={showSampleModal}
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
          width={600}
          className={style.sampleImgModal}
        >
          <Flex wrap={true} sp>
            {sampleImgs.map((item, index) => {
              return (
                <img
                  src={item}
                  key={`img_${index}`}
                  style={{
                    width: 'calc(50% - 8px)',
                    marginBottom: 16,
                    borderRadius: 4
                  }}
                />
              )
            })}
          </Flex>
        </Modal>
      </HeaderView>
    )
  }
}
